import { render, staticRenderFns } from "./r-simple-list-item.vue?vue&type=template&id=4915344c"
import script from "./r-simple-list-item.vue?vue&type=script&lang=js"
export * from "./r-simple-list-item.vue?vue&type=script&lang=js"
import style0 from "./r-simple-list-item.vue?vue&type=style&index=0&id=4915344c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports